/**
 * Main App Component
 * Handles authentication state and routing
 */

import React, { useEffect } from 'react';
import { CircularProgress, Box } from '@mui/material';

import { useAppSelector, useAppDispatch } from './store/hooks';
import { restoreSession, signOut } from './store/slices/authSlice';
import { apiClient } from './services/api';

import Layout from './components/Layout';
import LoginPage from './components/pages/LoginPage';

const App = () => {
  const dispatch = useAppDispatch();
  const { authenticated, loading } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(restoreSession());
    // ASS-60: wire the sign-out handler so ApiClient can dispatch a visible
    // sign-out when a 401 is irrecoverable (refresh token revoked or session
    // genuinely dead). This ensures the user sees the login page, never a
    // blank page or a silently-broken session.
    apiClient.setSignOutHandler(() => {
      dispatch(signOut());
    });
  }, [dispatch]);

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: 'background.default',
        }}
      >
        <CircularProgress color="primary" size={48} />
      </Box>
    );
  }

  return authenticated ? <Layout /> : <LoginPage />;
};

export default App;
